import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  getEmployeesOfShift,
  removeEmployeeFromShift,
} from "../actions/shiftActions";

import { confirmShift } from "../actions/companyEmployeeShiftActions";

import { Dialog, DialogTitle } from "@material-ui/core";

import DataList from "../components/DataList";
import UpdateCompanyEmployeeShiftForm from "../components/forms/UpdateCompanyEmployeeShiftForm";

import dateToDutchString from "../utils/date-to-dutch-string";

let credentials = JSON.parse(localStorage.getItem("credentials"));

const ShiftEmployeesList = (props) => {
  const [isFetching, setIsFetching] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [employees, setEmployees] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogPhoto, setDialogPhoto] = useState("");
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [companyEmployeeId, setCompanyEmployeeId] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setEmployees([]);
      setIsFetching(true);
      const _employees = await getEmployeesOfShift(props.shiftId);
      console.log(_employees);
      setEmployees(_employees);
    } catch (error) {
      console.error(error);
      setErrorMessage(error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleListItemClick = (employee) => {
    setIsDialogOpen(true);

    const photo = credentials.user.isAdmin
      ? employee.companies[0].cardPhoto
      : employee.facePhoto;
    const binaryPhoto = new Buffer(photo, "base64").toString("binary");

    setDialogPhoto(binaryPhoto);
  };

  const handleDeleteClick = async (employee) => {
    try {
      setIsFetching(true);
      const companyEmployeeId = employee.companies[0].id;

      await removeEmployeeFromShift(props.shiftId, companyEmployeeId);

      const _employees = employees.filter(
        (e) => e.companies[0].id !== companyEmployeeId,
      );
      setEmployees(_employees);

      setSuccessMessage("Medewerker van dienst verwijderen is voltooid");
    } catch (error) {
      console.error(error);
      setErrorMessage(error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleConfirmClick = (employee) => {
    confirmShift(employee.companies[0].id, props.shiftId);
    window.location.reload();
  };

  return (
    <Fragment>
      <DataList
        data={employees.map((employee, i) => {
          const _isConfirmedAt =
            employee.companies[0].shifts[0].CompanyEmployeeShift.isConfirmedAt;
          const isConfirmedAt = _isConfirmedAt
            ? dateToDutchString(_isConfirmedAt)
            : "";

          const _ctxMenu = [];

          if (!isConfirmedAt) {
            _ctxMenu.push({
              label: "Bevestigen",
              action: () => handleConfirmClick(employee),
            });
          }

          return {
            id: i,
            avatar: new Buffer(employee.facePhoto, "base64").toString("binary"),
            title: `${employee.firstName} ${employee.lastName} ${
              credentials.user.isAdmin
                ? "(" + employee.companies[0].company.name + ")"
                : ""
            } ${
              isConfirmedAt
                ? ` - Bevestigd op ${isConfirmedAt}`
                : " - Nog niet bevestigd"
            }`,
            subtitle: `Pasnummer: ${employee.companies[0].cardNumber}`,
            onClick: () => handleListItemClick(employee),
            ctxMenu: [
              ..._ctxMenu,
              {
                label: "Wijzigen",
                action: () => {
                  setIsUpdateDialogOpen(true);
                  setCompanyEmployeeId(employee.companies[0].id);
                },
              },
              {
                label: "Verwijderen",
                action: () => handleDeleteClick(employee),
                confirm: true,
                hide: !credentials.user.isAdmin,
              },
            ],
          };
        })}
        successMessage={successMessage}
        isFetching={isFetching}
        errorMessage={errorMessage}
      />

      <Dialog
        open={isUpdateDialogOpen}
        onClose={() => setIsUpdateDialogOpen(false)}
      >
        <DialogTitle id="dialog-update-shift-employee">
          Medewerker van dienst wijzigen
        </DialogTitle>
        <div style={{ padding: 10 }}>
          <UpdateCompanyEmployeeShiftForm
            companyEmployeeId={companyEmployeeId}
            shiftId={props.shiftId}
          />
        </div>
      </Dialog>

      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <DialogTitle id="dialog-employeecard">Medewerkerspas</DialogTitle>
        <img src={dialogPhoto} style={{ maxWidth: "100%", margin: "10px" }} />
      </Dialog>
    </Fragment>
  );
};

ShiftEmployeesList.propTypes = {
  shiftId: PropTypes.string.isRequired,
};

export default ShiftEmployeesList;



// WEBPACK FOOTER //
// ./src/components/ShiftEmployeesList.js